import React from 'react';
import QvPage from '../view/loading/pages/qv/QvPage';
import DaishinPage from '../view/loading/pages/daishin/DaishinPage';
import BTBMarket from '../view/loading/pages/btb/BTBMarket';

const TARGET_CONFIG_MAP = {
  qv: {
    id: 15,
    companyName: '한국의약품안전관리원',
    companyTel: '02-2172-6700',
    team: { id: 19 },
    value: 15,
    label: '한국의약품안전관리원',
    sid: 'SID1001',
    LoadingComponent: QvPage,
  },
  daishin: {
    id: 17,
    companyName: '퀀텀증권',
    companyTel: '1588-4488',
    value: 17,
    label: '퀀텀증권',
    LoadingComponent: DaishinPage,
  },
};

const DEFAULT_LOADING_COMPONENT = BTBMarket;

export function getTargetConfig(targetKey) {
  if (!targetKey) return null;
  return TARGET_CONFIG_MAP[targetKey] || null;
}

export function getLoadingComponent(targetConfig) {
  return targetConfig?.LoadingComponent || DEFAULT_LOADING_COMPONENT;
}

export function listTargetKeys() {
  return Object.keys(TARGET_CONFIG_MAP);
}

export function getAllTargets() {
  return Object.entries(TARGET_CONFIG_MAP).map(([key, value]) => ({
    key,
    ...value,
  }));
}
